import assetPath from '/app/packages/lebenslauf/articles/src/assets/der-perfekte-schlusssatz-fuer-deine.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')